<template>
	<div>
		<div class="main">
			<div v-if="!isLoading">
				<BaseSelect :label="$t('customer_consultant')" :options="dataOptions" v-model="selectedOption" />
			</div>
			<LoadingSpinner v-else />
		</div>

		<div class="flex justify-end">
			<BaseButton :disabled="isLoading" @click="save" class="mb-4 btn-blue">{{ $t('general.save') }}</BaseButton>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton';
import { CustomerconsultantsApiFactory, DamagecasesApiFactory, RepairshopsApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import stateMerge from 'vue-object-merge';
import { makeShadowCopy } from '@/plugins/Utils';
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';

export default {
	name: 'CustomerConsultant',
	components: { LoadingSpinner, BaseSelect, BaseButton },
	data() {
		return {
			dataOptions: [],
			selectedOption: null,
			model: {
				city: {
					zipCode: null,
					name: null,
				},
			},
			options: [],
			isLoading: true,
		};
	},
	methods: {
		init() {
			this.$store.dispatch('updateDamageCase', { id: parseInt(this.$route.params.processId || this.$route.params.id) }).then(() => {
				stateMerge(this.model, this.$store.getters.getDamageCase);
				this.model = makeShadowCopy(this.model);
				CustomerconsultantsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.customerconsultantsIdGet(this.$store.getters.getDamageCase.repairShop.company_id)
					.then(res => {
						const array = [];
						for (let i = 0; i < res.data.length; i++) {
							const customerConsultant = this.$store.getters.getDamageCase.customerConsultant;
							if (customerConsultant && res.data[i].id === customerConsultant?.id) {
								this.selectedOption = { display: res.data[i].first_name + ' ' + res.data[i].last_name, value: res.data[i].personable_id };
							}
							array.push({ display: res.data[i].first_name + ' ' + res.data[i].last_name, value: res.data[i].personable_id });
						}
						this.dataOptions = array;
						this.isLoading = false;
					})
					.catch(error => {
						this.isLoading = false;
						this.$swal(this.$t('general.attention').toString(), this.$t('no_companies_found').toString(), 'warning');
					});
			});
		},
		updateDamageCaseStore() {
			this.$store.dispatch('forceUpdateDamageCase', { id: parseInt(this.$route.params.processId || this.$route.params.id) });
		},
		save() {
			this.updateCustomerConsultant().then(_ => {
				this.updateDamageCaseStore();
				this.$store.commit('setConfirmLeaving', false);
			});
		},
		updateCustomerConsultant() {
			this.isLoading = true;
			return DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.damagecasesIdCustomerConsultantPut(parseInt(this.$route.params.processId || this.$route.params.id), {
					customer_consultant_id: this.selectedOption.value,
				})
				.then(response => {
					this.isLoading = false;
					this.$swal({
						title: this.$t('general.success').toString(),
						text: this.$t('customer_consultant_saved').toString(),
						icon: 'success',
					}).then(result => {
						this.$router.push({
							name: 'management.process.edit',
							params: { processId: this.$store.getters.getDamageCase.id, customer: this.$store.getters.getDamageCase.customer.id },
						});
					});
				})
				.catch(error => {
					this.isLoading = false;
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				});
		},
		updateDamagecase(showMessageBox) {
			return DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.damagecasesIdRepairShopPut(
					parseInt(this.$route.params.processId || this.$route.params.id),
					this.repairShopDesired ? this.model.repairShop : null,
				)
				.then(response => {
					if (showMessageBox) {
						this.$swal({
							title: this.$t('general.success').toString(),
							text: this.$t('company_assigned_to_damage_case').toString(),
							icon: 'success',
						}).then(result => {
							this.$store.commit('setConfirmLeaving', false);
							this.$router.push({
								name: 'management.process.edit',
								params: { processId: this.$store.getters.getDamageCase.id, customer: this.$store.getters.getDamageCase.customer.id },
							});
						});
					}
				})
				.catch(error => {
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				});
		},
	},
	mounted() {
		this.isLoading = true;
		this.init();
	},
};
</script>

<style scoped></style>
